import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonCheckedIcon from 'material-ui/svg-icons/toggle/radio-button-checked';
import RadioButtonUncheckedIcon from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import styles from './QuestionInfo.css';
import withTranslation from '../../../hoc/withTranslation';
import AddAPhotoIcon from 'material-ui/svg-icons/image/add-a-photo';
import EditIcon from 'material-ui/svg-icons/image/edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { IconButton } from 'material-ui';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { deleteQuizQuestionPicture, postQuizQuestionPicture } from '../../../store/quizzes/actions';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Loading from '../../common/Loading/Loading';
import { grey100 } from 'material-ui/styles/colors';

export class QuestionInfo extends React.Component {
    static supportedDropFiles = 'image/jpeg, image/png';
    static propTypes = {
        questionSending: PropTypes.bool,
        currentLang: PropTypes.string,
        app: PropTypes.object.isRequired,
        quiz: PropTypes.object.isRequired,
        question: PropTypes.object.isRequired,
        t: PropTypes.func,
        postQuizQuestionPicture: PropTypes.func,
        deleteQuizQuestionPicture: PropTypes.func,
    };

    state = {
        uploadingFiles: [],
        openRemovePicture: false,
    };

    handleOpenDeletePicture = () => {
        this.setState({ openRemovePicture: true });
    };
    handleCloseDeletePicture = () => {
        this.setState({ openRemovePicture: false });
    };

    handleRemovePicture = () => {
        this.props.deleteQuizQuestionPicture(
            this.props.app,
            this.props.quiz,
            this.props.question,
            this.props.currentLang,
        )
            .then(() => {
                this.setState({
                    openRemovePicture: false,
                });
            });
    };

    handlePictureDrop = (accepted, rejected) => {
        this.setState({ uploadingFiles: [] });

        accepted.forEach((picture) => {

            this.setState({ uploadingFiles: [] });
            console.log('Uploading file ' + picture.name);
            this.props.postQuizQuestionPicture(
                this.props.app,
                this.props.quiz,
                this.props.question,
                picture,
                this.props.currentLang,
                (progressEvent) => {
                    const percentCompleted = Math.round((
                        progressEvent.loaded * 100
                    ) / progressEvent.total);
                    const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media
                        !== picture);
                    console.log(picture.name
                        + ' -> '
                        + percentCompleted
                        + '% ('
                        + progressEvent.loaded
                        + ' / '
                        + progressEvent.total
                        + ')');
                    this.setState({
                        uploadingFiles: [
                            ...uploadingState,
                            {
                                picture: picture,
                                percent: percentCompleted,
                            },
                        ],
                    });
                },
            );
        });
    };

    renderDeletePictureDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.questionSending}
                onClick={this.handleCloseDeletePicture}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.questionSending}
                onClick={this.handleRemovePicture}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemovePicture}
                onRequestClose={this.handleCloseDeletePicture}
            >
                {this.props.questionSending && <Loading paper={false} />}
                {!this.props.questionSending &&
                    <p>{this.props.t('module.quiz.delete_question_picture_confirmation')}</p>
                }
            </Dialog>
        );
    }

    render() {
        const {
            question,
            t,
        } = this.props;
        return <div style={styles.paper}>
            <div style={{ width: '100%' }}>
                <div className="row" style={styles.row}>


                    <div style={{ position: 'relative', width: '300px', height: '300PX', backgroundColor: grey100 }}>
                        <div style={styles.imageContainer}>
                            {question.picture
                                && <img
                                    style={styles.image}
                                    src={question.picture}
                                    alt="question picture"
                                />}


                            {!question.picture &&
                                <Dropzone
                                    ref={(node) => {
                                        this.dropzoneRef = node;
                                    }}
                                    accept={QuestionInfo.supportedDropFiles}
                                    onDrop={this.handlePictureDrop}
                                    multiple={false}
                                    style={{ height: '100%', width: '100%' }}
                                >
                                    <IconButton style={{ height: '100%', width: '100%' }}>
                                        <AddAPhotoIcon style={styles.addPictureIcon} />
                                    </IconButton>
                                </Dropzone>
                            }
                        </div>

                        {question.picture &&
                            <div style={styles.pictureIconsContainer}>
                                <Dropzone
                                    ref={(node) => {
                                        this.dropzoneRef = node;
                                    }}
                                    accept={QuestionInfo.supportedDropFiles}
                                    onDrop={this.handlePictureDrop}
                                    multiple={false}
                                    style={{}}
                                >
                                    <IconButton style={styles.editIcon}>
                                        <EditIcon />
                                    </IconButton>
                                </Dropzone>
                                <IconButton
                                    style={styles.deleteIcon}
                                    onClick={this.handleOpenDeletePicture}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        }
                    </div>
                    <div style={{ marginLeft: '20px', flexGrow: 1 }}>
                        <p>
                            <span style={styles.questionPreTitle}>Question : </span> {question.title}
                        </p>
                        {question.hint && question.hint !== '' && <p>
                            <span style={styles.questionPreTitle}>{t('module.quiz.question.hint')} : </span> {question.hint}
                        </p>}
                        {question.information && question.information !== '' && <p>
                            <span style={styles.questionPreTitle}>{t('module.quiz.question.information')} : </span> {question.information}
                        </p>}
                        <p>
                            <span style={styles.questionPreTitle}>
                                {`${t('module.quiz.responses')} : `}
                            </span>
                        </p>
                        <ul>
                            {question.quiz_responses && question.quiz_responses.map(response => {
                                return <li style={styles.responseItem} key={response.id}>
                                    {response.is_valid
                                        ? <RadioButtonCheckedIcon style={styles.responseValidDot} />
                                        : <RadioButtonUncheckedIcon
                                            style={styles.responseInvalidDot} />
                                    }
                                    {response.label}
                                    {response.point !== null && response.point > 0 &&
                                        <span> ({t('module.quiz.point_count',
                                            { count: response.point },
                                        )})</span>
                                    }
                                </li>;
                            })}
                        </ul>
                    </div>
                </div>
            </div>
            {this.renderDeletePictureDialog()}
        </div>;
    }
}

function mapStateToProps(state, ownProps) {
    return {
        questionSending: state.quizzes.questionSending,
        currentLang: state.ui.currentLang,
    };
}

export default connect(
    mapStateToProps,
    {
        postQuizQuestionPicture,
        deleteQuizQuestionPicture,
    },
)(withTranslation(QuestionInfo));



// WEBPACK FOOTER //
// src/components/quiz/QuestionInfo/QuestionInfo.js